export default "__VITE_ASSET__CwECYjge__"